/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Crius API
 * The Crius API description
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import { useCallback } from 'react';

import type {
  AggregateClusterResponse,
  AggregateClustersParams,
  ClusterByIdResponse,
  ClustersParams,
  CreateAudioGenerationResponse,
  CreateAudioGenerationWithDatasetRequest,
  CreateAudioGenerationWithFileRequest,
  CreateDatasetRequest,
  CreateDatasetResponse,
  CreateDescribeImageResponse,
  CreateDescribeImageWithDatasetRequest,
  CreateDescribeImageWithFileRequest,
  CreateExtractStructureResponse,
  CreateExtractStructureWithDatasetRequest,
  CreateExtractStructureWithFileRequest,
  CreateFeedbackRequest,
  CreateFeedbackResponse,
  CreatePlaygroundTextTranslationRequest,
  CreateTextTranslationResponse,
  CreateTextTranslationWithDatasetRequest,
  CreateTextTranslationWithFileRequest,
  DatasetByIdResponse,
  DatasetOptionsParams,
  DatasetOptionsResponse,
  DatasetsParams,
  FilesResponse,
  LeaderboardParams,
  LeaderboardResponse,
  LoginRequest,
  LoginResponse,
  ModelRunsParams,
  Models,
  ModelsParams,
  PaginatedClusterResponse,
  PaginatedDatasetResponse,
  PaginatedModelRunResponse,
  StatisticsByTestEnvironmentParams,
  StatisticsResponse,
  UnusedModelsParams,
  UsersResponse,
} from './generated.schemas';

import { useCustomClient } from './instance';
import type { ErrorType, BodyType } from './instance';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Login
 */
export const useLoginHook = () => {
  const login = useCustomClient<LoginResponse>();

  return useCallback(
    (loginRequest: BodyType<LoginRequest>, signal?: AbortSignal) => {
      return login({
        url: `/api/auth/login`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: loginRequest,
        signal,
      });
    },
    [login]
  );
};

export const useLoginMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  const mutationKey = ['login'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const login = useLoginHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
    { data: BodyType<LoginRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useLoginHook>>>
>;
export type LoginMutationBody = BodyType<LoginRequest>;
export type LoginMutationError = ErrorType<unknown>;

/**
 * @summary Login
 */
export const useLogin = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
      TError,
      { data: BodyType<LoginRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  const mutationOptions = useLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const useAuthControllerProfileHook = () => {
  const authControllerProfile = useCustomClient<unknown>();

  return useCallback(
    (signal?: AbortSignal) => {
      return authControllerProfile({
        url: `/api/auth/profile`,
        method: 'GET',
        signal,
      });
    },
    [authControllerProfile]
  );
};

export const getAuthControllerProfileQueryKey = () => {
  return [`/api/auth/profile`] as const;
};

export const useAuthControllerProfileQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthControllerProfileQueryKey();

  const authControllerProfile = useAuthControllerProfileHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>
  > = ({ signal }) => authControllerProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthControllerProfileQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>
>;
export type AuthControllerProfileQueryError = ErrorType<void>;

export function useAuthControllerProfile<
  TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
  TError = ErrorType<void>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthControllerProfile<
  TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthControllerProfile<
  TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useAuthControllerProfile<
  TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useAuthControllerProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get user options
 */
export const useUserOptionsHook = () => {
  const userOptions = useCustomClient<UsersResponse>();

  return useCallback(
    (signal?: AbortSignal) => {
      return userOptions({ url: `/api/users/options`, method: 'GET', signal });
    },
    [userOptions]
  );
};

export const getUserOptionsQueryKey = () => {
  return [`/api/users/options`] as const;
};

export const useUserOptionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserOptionsQueryKey();

  const userOptions = useUserOptionsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>
  > = ({ signal }) => userOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UserOptionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>
>;
export type UserOptionsQueryError = ErrorType<void>;

export function useUserOptions<
  TData = Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>,
  TError = ErrorType<void>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserOptions<
  TData = Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserOptions<
  TData = Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user options
 */

export function useUserOptions<
  TData = Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useUserOptionsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserOptionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new dataset
 */
export const useCreateDatasetHook = () => {
  const createDataset = useCustomClient<CreateDatasetResponse>();

  return useCallback(
    (
      createDatasetRequest: BodyType<CreateDatasetRequest>,
      signal?: AbortSignal
    ) => {
      return createDataset({
        url: `/api/datasets`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createDatasetRequest,
        signal,
      });
    },
    [createDataset]
  );
};

export const useCreateDatasetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateDatasetHook>>>,
    TError,
    { data: BodyType<CreateDatasetRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateDatasetHook>>>,
  TError,
  { data: BodyType<CreateDatasetRequest> },
  TContext
> => {
  const mutationKey = ['createDataset'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createDataset = useCreateDatasetHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateDatasetHook>>>,
    { data: BodyType<CreateDatasetRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createDataset(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDatasetMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateDatasetHook>>>
>;
export type CreateDatasetMutationBody = BodyType<CreateDatasetRequest>;
export type CreateDatasetMutationError = ErrorType<void>;

/**
 * @summary Create a new dataset
 */
export const useCreateDataset = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useCreateDatasetHook>>>,
      TError,
      { data: BodyType<CreateDatasetRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateDatasetHook>>>,
  TError,
  { data: BodyType<CreateDatasetRequest> },
  TContext
> => {
  const mutationOptions = useCreateDatasetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get all datasets
 */
export const useDatasetsHook = () => {
  const datasets = useCustomClient<PaginatedDatasetResponse>();

  return useCallback(
    (params?: DatasetsParams, signal?: AbortSignal) => {
      return datasets({ url: `/api/datasets`, method: 'GET', params, signal });
    },
    [datasets]
  );
};

export const getDatasetsQueryKey = (params?: DatasetsParams) => {
  return [`/api/datasets`, ...(params ? [params] : [])] as const;
};

export const useDatasetsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
  TError = ErrorType<void>,
>(
  params?: DatasetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDatasetsQueryKey(params);

  const datasets = useDatasetsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>
  > = ({ signal }) => datasets(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DatasetsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>
>;
export type DatasetsQueryError = ErrorType<void>;

export function useDatasets<
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
  TError = ErrorType<void>,
>(
  params: undefined | DatasetsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDatasets<
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
  TError = ErrorType<void>,
>(
  params?: DatasetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDatasets<
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
  TError = ErrorType<void>,
>(
  params?: DatasetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all datasets
 */

export function useDatasets<
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
  TError = ErrorType<void>,
>(
  params?: DatasetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useDatasetsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get dataset options
 */
export const useDatasetOptionsHook = () => {
  const datasetOptions = useCustomClient<DatasetOptionsResponse>();

  return useCallback(
    (params?: DatasetOptionsParams, signal?: AbortSignal) => {
      return datasetOptions({
        url: `/api/datasets/options`,
        method: 'GET',
        params,
        signal,
      });
    },
    [datasetOptions]
  );
};

export const getDatasetOptionsQueryKey = (params?: DatasetOptionsParams) => {
  return [`/api/datasets/options`, ...(params ? [params] : [])] as const;
};

export const useDatasetOptionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>,
  TError = ErrorType<void>,
>(
  params?: DatasetOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDatasetOptionsQueryKey(params);

  const datasetOptions = useDatasetOptionsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>
  > = ({ signal }) => datasetOptions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DatasetOptionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>
>;
export type DatasetOptionsQueryError = ErrorType<void>;

export function useDatasetOptions<
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>,
  TError = ErrorType<void>,
>(
  params: undefined | DatasetOptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDatasetOptions<
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>,
  TError = ErrorType<void>,
>(
  params?: DatasetOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDatasetOptions<
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>,
  TError = ErrorType<void>,
>(
  params?: DatasetOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get dataset options
 */

export function useDatasetOptions<
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>,
  TError = ErrorType<void>,
>(
  params?: DatasetOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetOptionsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useDatasetOptionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a dataset by id
 */
export const useDatasetByIdHook = () => {
  const datasetById = useCustomClient<DatasetByIdResponse>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return datasetById({ url: `/api/datasets/${id}`, method: 'GET', signal });
    },
    [datasetById]
  );
};

export const getDatasetByIdQueryKey = (id: string) => {
  return [`/api/datasets/${id}`] as const;
};

export const useDatasetByIdQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDatasetByIdQueryKey(id);

  const datasetById = useDatasetByIdHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>
  > = ({ signal }) => datasetById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DatasetByIdQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>
>;
export type DatasetByIdQueryError = ErrorType<void>;

export function useDatasetById<
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>,
  TError = ErrorType<void>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDatasetById<
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDatasetById<
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a dataset by id
 */

export function useDatasetById<
  TData = Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDatasetByIdHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useDatasetByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get files
 */
export const useFilesHook = () => {
  const files = useCustomClient<FilesResponse>();

  return useCallback(
    (datasetId: string, signal?: AbortSignal) => {
      return files({ url: `/api/files/${datasetId}`, method: 'GET', signal });
    },
    [files]
  );
};

export const getFilesQueryKey = (datasetId: string) => {
  return [`/api/files/${datasetId}`] as const;
};

export const useFilesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
  TError = ErrorType<void>,
>(
  datasetId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilesQueryKey(datasetId);

  const files = useFilesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useFilesHook>>>
  > = ({ signal }) => files(datasetId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!datasetId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FilesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useFilesHook>>>
>;
export type FilesQueryError = ErrorType<void>;

export function useFiles<
  TData = Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
  TError = ErrorType<void>,
>(
  datasetId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFilesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFiles<
  TData = Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
  TError = ErrorType<void>,
>(
  datasetId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFilesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFiles<
  TData = Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
  TError = ErrorType<void>,
>(
  datasetId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get files
 */

export function useFiles<
  TData = Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
  TError = ErrorType<void>,
>(
  datasetId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useFilesQueryOptions(datasetId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download file
 */
export const useFileDownloadHook = () => {
  const fileDownload = useCustomClient<Blob>();

  return useCallback(
    (fileId: string, signal?: AbortSignal) => {
      return fileDownload({
        url: `/api/files/${fileId}/download`,
        method: 'GET',
        responseType: 'blob',
        signal,
      });
    },
    [fileDownload]
  );
};

export const getFileDownloadQueryKey = (fileId: string) => {
  return [`/api/files/${fileId}/download`] as const;
};

export const useFileDownloadQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>,
  TError = ErrorType<void>,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFileDownloadQueryKey(fileId);

  const fileDownload = useFileDownloadHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>
  > = ({ signal }) => fileDownload(fileId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!fileId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FileDownloadQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>
>;
export type FileDownloadQueryError = ErrorType<void>;

export function useFileDownload<
  TData = Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>,
  TError = ErrorType<void>,
>(
  fileId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFileDownload<
  TData = Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>,
  TError = ErrorType<void>,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFileDownload<
  TData = Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>,
  TError = ErrorType<void>,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download file
 */

export function useFileDownload<
  TData = Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>,
  TError = ErrorType<void>,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFileDownloadHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useFileDownloadQueryOptions(fileId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a lease for a file by utilizing a signed url
 */
export const useFileLeaseHook = () => {
  const fileLease = useCustomClient<string>();

  return useCallback(
    (fileId: string, signal?: AbortSignal) => {
      return fileLease({
        url: `/api/files/${fileId}/lease`,
        method: 'GET',
        signal,
      });
    },
    [fileLease]
  );
};

export const getFileLeaseQueryKey = (fileId: string) => {
  return [`/api/files/${fileId}/lease`] as const;
};

export const useFileLeaseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>,
  TError = ErrorType<void>,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFileLeaseQueryKey(fileId);

  const fileLease = useFileLeaseHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>
  > = ({ signal }) => fileLease(fileId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!fileId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FileLeaseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>
>;
export type FileLeaseQueryError = ErrorType<void>;

export function useFileLease<
  TData = Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>,
  TError = ErrorType<void>,
>(
  fileId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFileLease<
  TData = Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>,
  TError = ErrorType<void>,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFileLease<
  TData = Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>,
  TError = ErrorType<void>,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a lease for a file by utilizing a signed url
 */

export function useFileLease<
  TData = Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>,
  TError = ErrorType<void>,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useFileLeaseHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useFileLeaseQueryOptions(fileId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get models
 */
export const useModelsHook = () => {
  const models = useCustomClient<Models>();

  return useCallback(
    (params?: ModelsParams, signal?: AbortSignal) => {
      return models({ url: `/api/models`, method: 'GET', params, signal });
    },
    [models]
  );
};

export const getModelsQueryKey = (params?: ModelsParams) => {
  return [`/api/models`, ...(params ? [params] : [])] as const;
};

export const useModelsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useModelsHook>>>,
  TError = ErrorType<void>,
>(
  params?: ModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelsHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getModelsQueryKey(params);

  const models = useModelsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useModelsHook>>>
  > = ({ signal }) => models(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useModelsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ModelsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useModelsHook>>>
>;
export type ModelsQueryError = ErrorType<void>;

export function useModels<
  TData = Awaited<ReturnType<ReturnType<typeof useModelsHook>>>,
  TError = ErrorType<void>,
>(
  params: undefined | ModelsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useModelsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useModelsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useModels<
  TData = Awaited<ReturnType<ReturnType<typeof useModelsHook>>>,
  TError = ErrorType<void>,
>(
  params?: ModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useModelsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useModelsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useModels<
  TData = Awaited<ReturnType<ReturnType<typeof useModelsHook>>>,
  TError = ErrorType<void>,
>(
  params?: ModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get models
 */

export function useModels<
  TData = Awaited<ReturnType<ReturnType<typeof useModelsHook>>>,
  TError = ErrorType<void>,
>(
  params?: ModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useModelsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get unused models
 */
export const useUnusedModelsHook = () => {
  const unusedModels = useCustomClient<Models>();

  return useCallback(
    (params: UnusedModelsParams, signal?: AbortSignal) => {
      return unusedModels({
        url: `/api/models/unused`,
        method: 'GET',
        params,
        signal,
      });
    },
    [unusedModels]
  );
};

export const getUnusedModelsQueryKey = (params: UnusedModelsParams) => {
  return [`/api/models/unused`, ...(params ? [params] : [])] as const;
};

export const useUnusedModelsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>,
  TError = ErrorType<void>,
>(
  params: UnusedModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUnusedModelsQueryKey(params);

  const unusedModels = useUnusedModelsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>
  > = ({ signal }) => unusedModels(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UnusedModelsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>
>;
export type UnusedModelsQueryError = ErrorType<void>;

export function useUnusedModels<
  TData = Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>,
  TError = ErrorType<void>,
>(
  params: UnusedModelsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUnusedModels<
  TData = Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>,
  TError = ErrorType<void>,
>(
  params: UnusedModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUnusedModels<
  TData = Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>,
  TError = ErrorType<void>,
>(
  params: UnusedModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get unused models
 */

export function useUnusedModels<
  TData = Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>,
  TError = ErrorType<void>,
>(
  params: UnusedModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useUnusedModelsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUnusedModelsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all model runs
 */
export const useModelRunsHook = () => {
  const modelRuns = useCustomClient<PaginatedModelRunResponse>();

  return useCallback(
    (params?: ModelRunsParams, signal?: AbortSignal) => {
      return modelRuns({
        url: `/api/model-runs`,
        method: 'GET',
        params,
        signal,
      });
    },
    [modelRuns]
  );
};

export const getModelRunsQueryKey = (params?: ModelRunsParams) => {
  return [`/api/model-runs`, ...(params ? [params] : [])] as const;
};

export const useModelRunsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>,
  TError = ErrorType<void>,
>(
  params?: ModelRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getModelRunsQueryKey(params);

  const modelRuns = useModelRunsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>
  > = ({ signal }) => modelRuns(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ModelRunsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>
>;
export type ModelRunsQueryError = ErrorType<void>;

export function useModelRuns<
  TData = Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>,
  TError = ErrorType<void>,
>(
  params: undefined | ModelRunsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useModelRuns<
  TData = Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>,
  TError = ErrorType<void>,
>(
  params?: ModelRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useModelRuns<
  TData = Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>,
  TError = ErrorType<void>,
>(
  params?: ModelRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all model runs
 */

export function useModelRuns<
  TData = Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>,
  TError = ErrorType<void>,
>(
  params?: ModelRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelRunsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useModelRunsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useModelRunsControllerCreateHook = () => {
  const modelRunsControllerCreate = useCustomClient<void>();

  return useCallback(
    (modelRunId: string, signal?: AbortSignal) => {
      return modelRunsControllerCreate({
        url: `/api/model-runs/${modelRunId}/handle`,
        method: 'POST',
        signal,
      });
    },
    [modelRunsControllerCreate]
  );
};

export const useModelRunsControllerCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useModelRunsControllerCreateHook>>>,
    TError,
    { modelRunId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useModelRunsControllerCreateHook>>>,
  TError,
  { modelRunId: string },
  TContext
> => {
  const mutationKey = ['modelRunsControllerCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const modelRunsControllerCreate = useModelRunsControllerCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useModelRunsControllerCreateHook>>>,
    { modelRunId: string }
  > = (props) => {
    const { modelRunId } = props ?? {};

    return modelRunsControllerCreate(modelRunId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ModelRunsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useModelRunsControllerCreateHook>>>
>;

export type ModelRunsControllerCreateMutationError = ErrorType<unknown>;

export const useModelRunsControllerCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useModelRunsControllerCreateHook>>>,
      TError,
      { modelRunId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useModelRunsControllerCreateHook>>>,
  TError,
  { modelRunId: string },
  TContext
> => {
  const mutationOptions = useModelRunsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Download model run output
 */
export const useDownloadOutputHook = () => {
  const downloadOutput = useCustomClient<Blob>();

  return useCallback(
    (modelRunId: string, signal?: AbortSignal) => {
      return downloadOutput({
        url: `/api/model-runs/${modelRunId}/output`,
        method: 'GET',
        responseType: 'blob',
        signal,
      });
    },
    [downloadOutput]
  );
};

export const getDownloadOutputQueryKey = (modelRunId: string) => {
  return [`/api/model-runs/${modelRunId}/output`] as const;
};

export const useDownloadOutputQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadOutputQueryKey(modelRunId);

  const downloadOutput = useDownloadOutputHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>
  > = ({ signal }) => downloadOutput(modelRunId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!modelRunId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadOutputQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>
>;
export type DownloadOutputQueryError = ErrorType<void>;

export function useDownloadOutput<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadOutput<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadOutput<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download model run output
 */

export function useDownloadOutput<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadOutputHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useDownloadOutputQueryOptions(modelRunId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download reference
 */
export const useDownloadReferenceHook = () => {
  const downloadReference = useCustomClient<Blob>();

  return useCallback(
    (modelRunId: string, signal?: AbortSignal) => {
      return downloadReference({
        url: `/api/model-runs/${modelRunId}/reference`,
        method: 'GET',
        responseType: 'blob',
        signal,
      });
    },
    [downloadReference]
  );
};

export const getDownloadReferenceQueryKey = (modelRunId: string) => {
  return [`/api/model-runs/${modelRunId}/reference`] as const;
};

export const useDownloadReferenceQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadReferenceQueryKey(modelRunId);

  const downloadReference = useDownloadReferenceHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>
  > = ({ signal }) => downloadReference(modelRunId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!modelRunId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadReferenceQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>
>;
export type DownloadReferenceQueryError = ErrorType<void>;

export function useDownloadReference<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadReference<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadReference<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download reference
 */

export function useDownloadReference<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadReferenceHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useDownloadReferenceQueryOptions(modelRunId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download model run input
 */
export const useDownloadInputHook = () => {
  const downloadInput = useCustomClient<Blob>();

  return useCallback(
    (modelRunId: string, signal?: AbortSignal) => {
      return downloadInput({
        url: `/api/model-runs/${modelRunId}/input`,
        method: 'GET',
        responseType: 'blob',
        signal,
      });
    },
    [downloadInput]
  );
};

export const getDownloadInputQueryKey = (modelRunId: string) => {
  return [`/api/model-runs/${modelRunId}/input`] as const;
};

export const useDownloadInputQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadInputQueryKey(modelRunId);

  const downloadInput = useDownloadInputHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>
  > = ({ signal }) => downloadInput(modelRunId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!modelRunId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadInputQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>
>;
export type DownloadInputQueryError = ErrorType<void>;

export function useDownloadInput<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadInput<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadInput<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download model run input
 */

export function useDownloadInput<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadInputHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useDownloadInputQueryOptions(modelRunId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get model run parameters
 */
export const useModelRunParametersHook = () => {
  const modelRunParameters = useCustomClient<string>();

  return useCallback(
    (modelRunId: string, signal?: AbortSignal) => {
      return modelRunParameters({
        url: `/api/model-runs/${modelRunId}/parameters`,
        method: 'GET',
        signal,
      });
    },
    [modelRunParameters]
  );
};

export const getModelRunParametersQueryKey = (modelRunId: string) => {
  return [`/api/model-runs/${modelRunId}/parameters`] as const;
};

export const useModelRunParametersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getModelRunParametersQueryKey(modelRunId);

  const modelRunParameters = useModelRunParametersHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>
  > = ({ signal }) => modelRunParameters(modelRunId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!modelRunId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ModelRunParametersQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>
>;
export type ModelRunParametersQueryError = ErrorType<void>;

export function useModelRunParameters<
  TData = Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useModelRunParameters<
  TData = Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useModelRunParameters<
  TData = Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get model run parameters
 */

export function useModelRunParameters<
  TData = Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>,
  TError = ErrorType<void>,
>(
  modelRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useModelRunParametersHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useModelRunParametersQueryOptions(modelRunId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all clusters
 */
export const useClustersHook = () => {
  const clusters = useCustomClient<PaginatedClusterResponse>();

  return useCallback(
    (params?: ClustersParams, signal?: AbortSignal) => {
      return clusters({ url: `/api/clusters`, method: 'GET', params, signal });
    },
    [clusters]
  );
};

export const getClustersQueryKey = (params?: ClustersParams) => {
  return [`/api/clusters`, ...(params ? [params] : [])] as const;
};

export const useClustersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
  TError = ErrorType<void>,
>(
  params?: ClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getClustersQueryKey(params);

  const clusters = useClustersHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useClustersHook>>>
  > = ({ signal }) => clusters(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ClustersQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useClustersHook>>>
>;
export type ClustersQueryError = ErrorType<void>;

export function useClusters<
  TData = Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
  TError = ErrorType<void>,
>(
  params: undefined | ClustersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useClustersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useClusters<
  TData = Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
  TError = ErrorType<void>,
>(
  params?: ClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useClustersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useClusters<
  TData = Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
  TError = ErrorType<void>,
>(
  params?: ClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all clusters
 */

export function useClusters<
  TData = Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
  TError = ErrorType<void>,
>(
  params?: ClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useClustersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a cluster details
 */
export const useClusterByIdHook = () => {
  const clusterById = useCustomClient<ClusterByIdResponse>();

  return useCallback(
    (clusterId: string, signal?: AbortSignal) => {
      return clusterById({
        url: `/api/clusters/${clusterId}`,
        method: 'GET',
        signal,
      });
    },
    [clusterById]
  );
};

export const getClusterByIdQueryKey = (clusterId: string) => {
  return [`/api/clusters/${clusterId}`] as const;
};

export const useClusterByIdQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>,
  TError = ErrorType<void>,
>(
  clusterId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getClusterByIdQueryKey(clusterId);

  const clusterById = useClusterByIdHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>
  > = ({ signal }) => clusterById(clusterId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!clusterId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ClusterByIdQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>
>;
export type ClusterByIdQueryError = ErrorType<void>;

export function useClusterById<
  TData = Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>,
  TError = ErrorType<void>,
>(
  clusterId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useClusterById<
  TData = Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>,
  TError = ErrorType<void>,
>(
  clusterId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useClusterById<
  TData = Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>,
  TError = ErrorType<void>,
>(
  clusterId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a cluster details
 */

export function useClusterById<
  TData = Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>,
  TError = ErrorType<void>,
>(
  clusterId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterByIdHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useClusterByIdQueryOptions(clusterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useMetricsControllerCreateHook = () => {
  const metricsControllerCreate = useCustomClient<void>();

  return useCallback(
    (metricId: string, signal?: AbortSignal) => {
      return metricsControllerCreate({
        url: `/api/metrics/${metricId}/handle`,
        method: 'POST',
        signal,
      });
    },
    [metricsControllerCreate]
  );
};

export const useMetricsControllerCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useMetricsControllerCreateHook>>>,
    TError,
    { metricId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useMetricsControllerCreateHook>>>,
  TError,
  { metricId: string },
  TContext
> => {
  const mutationKey = ['metricsControllerCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const metricsControllerCreate = useMetricsControllerCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useMetricsControllerCreateHook>>>,
    { metricId: string }
  > = (props) => {
    const { metricId } = props ?? {};

    return metricsControllerCreate(metricId);
  };

  return { mutationFn, ...mutationOptions };
};

export type MetricsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useMetricsControllerCreateHook>>>
>;

export type MetricsControllerCreateMutationError = ErrorType<unknown>;

export const useMetricsControllerCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useMetricsControllerCreateHook>>>,
      TError,
      { metricId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useMetricsControllerCreateHook>>>,
  TError,
  { metricId: string },
  TContext
> => {
  const mutationOptions = useMetricsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Aggregate cluster metrics
 */
export const useAggregateClustersHook = () => {
  const aggregateClusters = useCustomClient<AggregateClusterResponse>();

  return useCallback(
    (params: AggregateClustersParams, signal?: AbortSignal) => {
      return aggregateClusters({
        url: `/api/metrics/clusters/aggregate`,
        method: 'GET',
        params,
        signal,
      });
    },
    [aggregateClusters]
  );
};

export const getAggregateClustersQueryKey = (
  params: AggregateClustersParams
) => {
  return [
    `/api/metrics/clusters/aggregate`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAggregateClustersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>,
  TError = ErrorType<void>,
>(
  params: AggregateClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAggregateClustersQueryKey(params);

  const aggregateClusters = useAggregateClustersHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>
  > = ({ signal }) => aggregateClusters(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AggregateClustersQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>
>;
export type AggregateClustersQueryError = ErrorType<void>;

export function useAggregateClusters<
  TData = Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>,
  TError = ErrorType<void>,
>(
  params: AggregateClustersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAggregateClusters<
  TData = Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>,
  TError = ErrorType<void>,
>(
  params: AggregateClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAggregateClusters<
  TData = Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>,
  TError = ErrorType<void>,
>(
  params: AggregateClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Aggregate cluster metrics
 */

export function useAggregateClusters<
  TData = Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>,
  TError = ErrorType<void>,
>(
  params: AggregateClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAggregateClustersHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useAggregateClustersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new text translation model run bypassing the dataset management, using a single file
 */
export const useCreateTextTranslationWithFileHook = () => {
  const createTextTranslationWithFile =
    useCustomClient<CreateTextTranslationResponse>();

  return useCallback(
    (
      createTextTranslationWithFileRequest: BodyType<CreateTextTranslationWithFileRequest>,
      signal?: AbortSignal
    ) => {
      return createTextTranslationWithFile({
        url: `/api/tasks/text-translation/file`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createTextTranslationWithFileRequest,
        signal,
      });
    },
    [createTextTranslationWithFile]
  );
};

export const useCreateTextTranslationWithFileMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCreateTextTranslationWithFileHook>>
    >,
    TError,
    { data: BodyType<CreateTextTranslationWithFileRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateTextTranslationWithFileHook>>>,
  TError,
  { data: BodyType<CreateTextTranslationWithFileRequest> },
  TContext
> => {
  const mutationKey = ['createTextTranslationWithFile'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createTextTranslationWithFile = useCreateTextTranslationWithFileHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCreateTextTranslationWithFileHook>>
    >,
    { data: BodyType<CreateTextTranslationWithFileRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createTextTranslationWithFile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTextTranslationWithFileMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateTextTranslationWithFileHook>>>
>;
export type CreateTextTranslationWithFileMutationBody =
  BodyType<CreateTextTranslationWithFileRequest>;
export type CreateTextTranslationWithFileMutationError = ErrorType<void>;

/**
 * @summary Create a new text translation model run bypassing the dataset management, using a single file
 */
export const useCreateTextTranslationWithFile = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<ReturnType<typeof useCreateTextTranslationWithFileHook>>
      >,
      TError,
      { data: BodyType<CreateTextTranslationWithFileRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateTextTranslationWithFileHook>>>,
  TError,
  { data: BodyType<CreateTextTranslationWithFileRequest> },
  TContext
> => {
  const mutationOptions =
    useCreateTextTranslationWithFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create a new text translation model run, using a dataset
 */
export const useCreateTextTranslationWithDatasetHook = () => {
  const createTextTranslationWithDataset =
    useCustomClient<CreateTextTranslationResponse>();

  return useCallback(
    (
      createTextTranslationWithDatasetRequest: BodyType<CreateTextTranslationWithDatasetRequest>,
      signal?: AbortSignal
    ) => {
      return createTextTranslationWithDataset({
        url: `/api/tasks/text-translation/dataset`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createTextTranslationWithDatasetRequest,
        signal,
      });
    },
    [createTextTranslationWithDataset]
  );
};

export const useCreateTextTranslationWithDatasetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCreateTextTranslationWithDatasetHook>>
    >,
    TError,
    { data: BodyType<CreateTextTranslationWithDatasetRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useCreateTextTranslationWithDatasetHook>>
  >,
  TError,
  { data: BodyType<CreateTextTranslationWithDatasetRequest> },
  TContext
> => {
  const mutationKey = ['createTextTranslationWithDataset'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createTextTranslationWithDataset =
    useCreateTextTranslationWithDatasetHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCreateTextTranslationWithDatasetHook>>
    >,
    { data: BodyType<CreateTextTranslationWithDatasetRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createTextTranslationWithDataset(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTextTranslationWithDatasetMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useCreateTextTranslationWithDatasetHook>>
  >
>;
export type CreateTextTranslationWithDatasetMutationBody =
  BodyType<CreateTextTranslationWithDatasetRequest>;
export type CreateTextTranslationWithDatasetMutationError = ErrorType<void>;

/**
 * @summary Create a new text translation model run, using a dataset
 */
export const useCreateTextTranslationWithDataset = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<ReturnType<typeof useCreateTextTranslationWithDatasetHook>>
      >,
      TError,
      { data: BodyType<CreateTextTranslationWithDatasetRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useCreateTextTranslationWithDatasetHook>>
  >,
  TError,
  { data: BodyType<CreateTextTranslationWithDatasetRequest> },
  TContext
> => {
  const mutationOptions =
    useCreateTextTranslationWithDatasetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create a new text translation model run using the playground
 */
export const useCreatePlaygroundTextTranslationHook = () => {
  const createPlaygroundTextTranslation =
    useCustomClient<CreateTextTranslationResponse>();

  return useCallback(
    (
      createPlaygroundTextTranslationRequest: BodyType<CreatePlaygroundTextTranslationRequest>,
      signal?: AbortSignal
    ) => {
      return createPlaygroundTextTranslation({
        url: `/api/tasks/text-translation/playground`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createPlaygroundTextTranslationRequest,
        signal,
      });
    },
    [createPlaygroundTextTranslation]
  );
};

export const useCreatePlaygroundTextTranslationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCreatePlaygroundTextTranslationHook>>
    >,
    TError,
    { data: BodyType<CreatePlaygroundTextTranslationRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useCreatePlaygroundTextTranslationHook>>
  >,
  TError,
  { data: BodyType<CreatePlaygroundTextTranslationRequest> },
  TContext
> => {
  const mutationKey = ['createPlaygroundTextTranslation'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createPlaygroundTextTranslation =
    useCreatePlaygroundTextTranslationHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCreatePlaygroundTextTranslationHook>>
    >,
    { data: BodyType<CreatePlaygroundTextTranslationRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createPlaygroundTextTranslation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePlaygroundTextTranslationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreatePlaygroundTextTranslationHook>>>
>;
export type CreatePlaygroundTextTranslationMutationBody =
  BodyType<CreatePlaygroundTextTranslationRequest>;
export type CreatePlaygroundTextTranslationMutationError = ErrorType<void>;

/**
 * @summary Create a new text translation model run using the playground
 */
export const useCreatePlaygroundTextTranslation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<ReturnType<typeof useCreatePlaygroundTextTranslationHook>>
      >,
      TError,
      { data: BodyType<CreatePlaygroundTextTranslationRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useCreatePlaygroundTextTranslationHook>>
  >,
  TError,
  { data: BodyType<CreatePlaygroundTextTranslationRequest> },
  TContext
> => {
  const mutationOptions =
    useCreatePlaygroundTextTranslationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create a new audio generation model run, using a single file
 */
export const useCreateAudioGenerationWithFileHook = () => {
  const createAudioGenerationWithFile =
    useCustomClient<CreateAudioGenerationResponse>();

  return useCallback(
    (
      createAudioGenerationWithFileRequest: BodyType<CreateAudioGenerationWithFileRequest>,
      signal?: AbortSignal
    ) => {
      return createAudioGenerationWithFile({
        url: `/api/tasks/generate-audio/file`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createAudioGenerationWithFileRequest,
        signal,
      });
    },
    [createAudioGenerationWithFile]
  );
};

export const useCreateAudioGenerationWithFileMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCreateAudioGenerationWithFileHook>>
    >,
    TError,
    { data: BodyType<CreateAudioGenerationWithFileRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateAudioGenerationWithFileHook>>>,
  TError,
  { data: BodyType<CreateAudioGenerationWithFileRequest> },
  TContext
> => {
  const mutationKey = ['createAudioGenerationWithFile'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createAudioGenerationWithFile = useCreateAudioGenerationWithFileHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCreateAudioGenerationWithFileHook>>
    >,
    { data: BodyType<CreateAudioGenerationWithFileRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createAudioGenerationWithFile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAudioGenerationWithFileMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateAudioGenerationWithFileHook>>>
>;
export type CreateAudioGenerationWithFileMutationBody =
  BodyType<CreateAudioGenerationWithFileRequest>;
export type CreateAudioGenerationWithFileMutationError = ErrorType<void>;

/**
 * @summary Create a new audio generation model run, using a single file
 */
export const useCreateAudioGenerationWithFile = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<ReturnType<typeof useCreateAudioGenerationWithFileHook>>
      >,
      TError,
      { data: BodyType<CreateAudioGenerationWithFileRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateAudioGenerationWithFileHook>>>,
  TError,
  { data: BodyType<CreateAudioGenerationWithFileRequest> },
  TContext
> => {
  const mutationOptions =
    useCreateAudioGenerationWithFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create a new Audio Generation model run, using a dataset
 */
export const useCreateAudioGenerationWithDatasetHook = () => {
  const createAudioGenerationWithDataset =
    useCustomClient<CreateAudioGenerationResponse>();

  return useCallback(
    (
      createAudioGenerationWithDatasetRequest: BodyType<CreateAudioGenerationWithDatasetRequest>,
      signal?: AbortSignal
    ) => {
      return createAudioGenerationWithDataset({
        url: `/api/tasks/generate-audio/dataset`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createAudioGenerationWithDatasetRequest,
        signal,
      });
    },
    [createAudioGenerationWithDataset]
  );
};

export const useCreateAudioGenerationWithDatasetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCreateAudioGenerationWithDatasetHook>>
    >,
    TError,
    { data: BodyType<CreateAudioGenerationWithDatasetRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useCreateAudioGenerationWithDatasetHook>>
  >,
  TError,
  { data: BodyType<CreateAudioGenerationWithDatasetRequest> },
  TContext
> => {
  const mutationKey = ['createAudioGenerationWithDataset'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createAudioGenerationWithDataset =
    useCreateAudioGenerationWithDatasetHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCreateAudioGenerationWithDatasetHook>>
    >,
    { data: BodyType<CreateAudioGenerationWithDatasetRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createAudioGenerationWithDataset(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAudioGenerationWithDatasetMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useCreateAudioGenerationWithDatasetHook>>
  >
>;
export type CreateAudioGenerationWithDatasetMutationBody =
  BodyType<CreateAudioGenerationWithDatasetRequest>;
export type CreateAudioGenerationWithDatasetMutationError = ErrorType<void>;

/**
 * @summary Create a new Audio Generation model run, using a dataset
 */
export const useCreateAudioGenerationWithDataset = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<ReturnType<typeof useCreateAudioGenerationWithDatasetHook>>
      >,
      TError,
      { data: BodyType<CreateAudioGenerationWithDatasetRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useCreateAudioGenerationWithDatasetHook>>
  >,
  TError,
  { data: BodyType<CreateAudioGenerationWithDatasetRequest> },
  TContext
> => {
  const mutationOptions =
    useCreateAudioGenerationWithDatasetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create a new Describe Image model run, using a dataset
 */
export const useCreateDescribeImageWithDatasetHook = () => {
  const createDescribeImageWithDataset =
    useCustomClient<CreateDescribeImageResponse>();

  return useCallback(
    (
      createDescribeImageWithDatasetRequest: BodyType<CreateDescribeImageWithDatasetRequest>,
      signal?: AbortSignal
    ) => {
      return createDescribeImageWithDataset({
        url: `/api/tasks/describe-image/dataset`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createDescribeImageWithDatasetRequest,
        signal,
      });
    },
    [createDescribeImageWithDataset]
  );
};

export const useCreateDescribeImageWithDatasetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCreateDescribeImageWithDatasetHook>>
    >,
    TError,
    { data: BodyType<CreateDescribeImageWithDatasetRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateDescribeImageWithDatasetHook>>>,
  TError,
  { data: BodyType<CreateDescribeImageWithDatasetRequest> },
  TContext
> => {
  const mutationKey = ['createDescribeImageWithDataset'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createDescribeImageWithDataset =
    useCreateDescribeImageWithDatasetHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCreateDescribeImageWithDatasetHook>>
    >,
    { data: BodyType<CreateDescribeImageWithDatasetRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createDescribeImageWithDataset(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDescribeImageWithDatasetMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateDescribeImageWithDatasetHook>>>
>;
export type CreateDescribeImageWithDatasetMutationBody =
  BodyType<CreateDescribeImageWithDatasetRequest>;
export type CreateDescribeImageWithDatasetMutationError = ErrorType<void>;

/**
 * @summary Create a new Describe Image model run, using a dataset
 */
export const useCreateDescribeImageWithDataset = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<ReturnType<typeof useCreateDescribeImageWithDatasetHook>>
      >,
      TError,
      { data: BodyType<CreateDescribeImageWithDatasetRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateDescribeImageWithDatasetHook>>>,
  TError,
  { data: BodyType<CreateDescribeImageWithDatasetRequest> },
  TContext
> => {
  const mutationOptions =
    useCreateDescribeImageWithDatasetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create a new Describe Image model run bypassing the dataset management, using a single file
 */
export const useCreateDescribeImageWithFileHook = () => {
  const createDescribeImageWithFile =
    useCustomClient<CreateDescribeImageResponse>();

  return useCallback(
    (
      createDescribeImageWithFileRequest: BodyType<CreateDescribeImageWithFileRequest>,
      signal?: AbortSignal
    ) => {
      return createDescribeImageWithFile({
        url: `/api/tasks/describe-image/file`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createDescribeImageWithFileRequest,
        signal,
      });
    },
    [createDescribeImageWithFile]
  );
};

export const useCreateDescribeImageWithFileMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateDescribeImageWithFileHook>>>,
    TError,
    { data: BodyType<CreateDescribeImageWithFileRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateDescribeImageWithFileHook>>>,
  TError,
  { data: BodyType<CreateDescribeImageWithFileRequest> },
  TContext
> => {
  const mutationKey = ['createDescribeImageWithFile'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createDescribeImageWithFile = useCreateDescribeImageWithFileHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateDescribeImageWithFileHook>>>,
    { data: BodyType<CreateDescribeImageWithFileRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createDescribeImageWithFile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDescribeImageWithFileMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateDescribeImageWithFileHook>>>
>;
export type CreateDescribeImageWithFileMutationBody =
  BodyType<CreateDescribeImageWithFileRequest>;
export type CreateDescribeImageWithFileMutationError = ErrorType<void>;

/**
 * @summary Create a new Describe Image model run bypassing the dataset management, using a single file
 */
export const useCreateDescribeImageWithFile = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<ReturnType<typeof useCreateDescribeImageWithFileHook>>
      >,
      TError,
      { data: BodyType<CreateDescribeImageWithFileRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateDescribeImageWithFileHook>>>,
  TError,
  { data: BodyType<CreateDescribeImageWithFileRequest> },
  TContext
> => {
  const mutationOptions =
    useCreateDescribeImageWithFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create a new extract structure model run bypassing the dataset management, using a single file
 */
export const useCreateExtractStructureWithFileHook = () => {
  const createExtractStructureWithFile =
    useCustomClient<CreateExtractStructureResponse>();

  return useCallback(
    (
      createExtractStructureWithFileRequest: BodyType<CreateExtractStructureWithFileRequest>,
      signal?: AbortSignal
    ) => {
      return createExtractStructureWithFile({
        url: `/api/tasks/extract-structure/file`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createExtractStructureWithFileRequest,
        signal,
      });
    },
    [createExtractStructureWithFile]
  );
};

export const useCreateExtractStructureWithFileMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCreateExtractStructureWithFileHook>>
    >,
    TError,
    { data: BodyType<CreateExtractStructureWithFileRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateExtractStructureWithFileHook>>>,
  TError,
  { data: BodyType<CreateExtractStructureWithFileRequest> },
  TContext
> => {
  const mutationKey = ['createExtractStructureWithFile'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createExtractStructureWithFile =
    useCreateExtractStructureWithFileHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCreateExtractStructureWithFileHook>>
    >,
    { data: BodyType<CreateExtractStructureWithFileRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createExtractStructureWithFile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateExtractStructureWithFileMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateExtractStructureWithFileHook>>>
>;
export type CreateExtractStructureWithFileMutationBody =
  BodyType<CreateExtractStructureWithFileRequest>;
export type CreateExtractStructureWithFileMutationError = ErrorType<void>;

/**
 * @summary Create a new extract structure model run bypassing the dataset management, using a single file
 */
export const useCreateExtractStructureWithFile = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<ReturnType<typeof useCreateExtractStructureWithFileHook>>
      >,
      TError,
      { data: BodyType<CreateExtractStructureWithFileRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateExtractStructureWithFileHook>>>,
  TError,
  { data: BodyType<CreateExtractStructureWithFileRequest> },
  TContext
> => {
  const mutationOptions =
    useCreateExtractStructureWithFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create a new Extract Structure model run, using a dataset
 */
export const useCreateExtractStructureWithDatasetHook = () => {
  const createExtractStructureWithDataset =
    useCustomClient<CreateExtractStructureResponse>();

  return useCallback(
    (
      createExtractStructureWithDatasetRequest: BodyType<CreateExtractStructureWithDatasetRequest>,
      signal?: AbortSignal
    ) => {
      return createExtractStructureWithDataset({
        url: `/api/tasks/extract-structure/dataset`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createExtractStructureWithDatasetRequest,
        signal,
      });
    },
    [createExtractStructureWithDataset]
  );
};

export const useCreateExtractStructureWithDatasetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCreateExtractStructureWithDatasetHook>>
    >,
    TError,
    { data: BodyType<CreateExtractStructureWithDatasetRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useCreateExtractStructureWithDatasetHook>>
  >,
  TError,
  { data: BodyType<CreateExtractStructureWithDatasetRequest> },
  TContext
> => {
  const mutationKey = ['createExtractStructureWithDataset'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createExtractStructureWithDataset =
    useCreateExtractStructureWithDatasetHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCreateExtractStructureWithDatasetHook>>
    >,
    { data: BodyType<CreateExtractStructureWithDatasetRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createExtractStructureWithDataset(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateExtractStructureWithDatasetMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useCreateExtractStructureWithDatasetHook>>
  >
>;
export type CreateExtractStructureWithDatasetMutationBody =
  BodyType<CreateExtractStructureWithDatasetRequest>;
export type CreateExtractStructureWithDatasetMutationError = ErrorType<void>;

/**
 * @summary Create a new Extract Structure model run, using a dataset
 */
export const useCreateExtractStructureWithDataset = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<ReturnType<typeof useCreateExtractStructureWithDatasetHook>>
      >,
      TError,
      { data: BodyType<CreateExtractStructureWithDatasetRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useCreateExtractStructureWithDatasetHook>>
  >,
  TError,
  { data: BodyType<CreateExtractStructureWithDatasetRequest> },
  TContext
> => {
  const mutationOptions =
    useCreateExtractStructureWithDatasetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Post feedback for a model run
 */
export const useCreateFeedbackHook = () => {
  const createFeedback = useCustomClient<CreateFeedbackResponse>();

  return useCallback(
    (
      modelRunId: string,
      createFeedbackRequest: BodyType<CreateFeedbackRequest>,
      signal?: AbortSignal
    ) => {
      return createFeedback({
        url: `/api/feedback/${modelRunId}`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createFeedbackRequest,
        signal,
      });
    },
    [createFeedback]
  );
};

export const useCreateFeedbackMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateFeedbackHook>>>,
    TError,
    { modelRunId: string; data: BodyType<CreateFeedbackRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateFeedbackHook>>>,
  TError,
  { modelRunId: string; data: BodyType<CreateFeedbackRequest> },
  TContext
> => {
  const mutationKey = ['createFeedback'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createFeedback = useCreateFeedbackHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateFeedbackHook>>>,
    { modelRunId: string; data: BodyType<CreateFeedbackRequest> }
  > = (props) => {
    const { modelRunId, data } = props ?? {};

    return createFeedback(modelRunId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateFeedbackHook>>>
>;
export type CreateFeedbackMutationBody = BodyType<CreateFeedbackRequest>;
export type CreateFeedbackMutationError = ErrorType<void>;

/**
 * @summary Post feedback for a model run
 */
export const useCreateFeedback = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useCreateFeedbackHook>>>,
      TError,
      { modelRunId: string; data: BodyType<CreateFeedbackRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateFeedbackHook>>>,
  TError,
  { modelRunId: string; data: BodyType<CreateFeedbackRequest> },
  TContext
> => {
  const mutationOptions = useCreateFeedbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the leaderboard
 */
export const useLeaderboardHook = () => {
  const leaderboard = useCustomClient<LeaderboardResponse>();

  return useCallback(
    (params: LeaderboardParams, signal?: AbortSignal) => {
      return leaderboard({
        url: `/api/leaderboard`,
        method: 'GET',
        params,
        signal,
      });
    },
    [leaderboard]
  );
};

export const getLeaderboardQueryKey = (params: LeaderboardParams) => {
  return [`/api/leaderboard`, ...(params ? [params] : [])] as const;
};

export const useLeaderboardQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>,
  TError = ErrorType<void>,
>(
  params: LeaderboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLeaderboardQueryKey(params);

  const leaderboard = useLeaderboardHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>
  > = ({ signal }) => leaderboard(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>
>;
export type LeaderboardQueryError = ErrorType<void>;

export function useLeaderboard<
  TData = Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>,
  TError = ErrorType<void>,
>(
  params: LeaderboardParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLeaderboard<
  TData = Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>,
  TError = ErrorType<void>,
>(
  params: LeaderboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLeaderboard<
  TData = Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>,
  TError = ErrorType<void>,
>(
  params: LeaderboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the leaderboard
 */

export function useLeaderboard<
  TData = Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>,
  TError = ErrorType<void>,
>(
  params: LeaderboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useLeaderboardHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useLeaderboardQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get statistic for the test environment
 */
export const useStatisticsByTestEnvironmentHook = () => {
  const statisticsByTestEnvironment = useCustomClient<StatisticsResponse>();

  return useCallback(
    (params?: StatisticsByTestEnvironmentParams, signal?: AbortSignal) => {
      return statisticsByTestEnvironment({
        url: `/api/statistics/test-environment`,
        method: 'GET',
        params,
        signal,
      });
    },
    [statisticsByTestEnvironment]
  );
};

export const getStatisticsByTestEnvironmentQueryKey = (
  params?: StatisticsByTestEnvironmentParams
) => {
  return [
    `/api/statistics/test-environment`,
    ...(params ? [params] : []),
  ] as const;
};

export const useStatisticsByTestEnvironmentQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
  >,
  TError = ErrorType<void>,
>(
  params?: StatisticsByTestEnvironmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStatisticsByTestEnvironmentQueryKey(params);

  const statisticsByTestEnvironment = useStatisticsByTestEnvironmentHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>>
  > = ({ signal }) => statisticsByTestEnvironment(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StatisticsByTestEnvironmentQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>>
>;
export type StatisticsByTestEnvironmentQueryError = ErrorType<void>;

export function useStatisticsByTestEnvironment<
  TData = Awaited<
    ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
  >,
  TError = ErrorType<void>,
>(
  params: undefined | StatisticsByTestEnvironmentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
          >,
          TError,
          Awaited<
            ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStatisticsByTestEnvironment<
  TData = Awaited<
    ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
  >,
  TError = ErrorType<void>,
>(
  params?: StatisticsByTestEnvironmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
          >,
          TError,
          Awaited<
            ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStatisticsByTestEnvironment<
  TData = Awaited<
    ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
  >,
  TError = ErrorType<void>,
>(
  params?: StatisticsByTestEnvironmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get statistic for the test environment
 */

export function useStatisticsByTestEnvironment<
  TData = Awaited<
    ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
  >,
  TError = ErrorType<void>,
>(
  params?: StatisticsByTestEnvironmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useStatisticsByTestEnvironmentHook>>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useStatisticsByTestEnvironmentQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
